import styled from "styled-components";

export const MainNavContentWrapperBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  color: ${props => props.theme.colors.text};
`